import { createFileRoute } from "@tanstack/react-router";
import Component from "./-components/component";
import { httpClient } from "@/httpClient";
import getPharmacyID from "@/utils/pharmacy_code";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import {
  InvoicingOverview,
  InvoicingRevevue,
} from "@/routes/(pharma)/_layout/invoicing/-data/schema";
import { Loading } from "@/layouts/loading";
import { ListOfReportsSchema } from "@/components/command-modal/models";
import { OverviewReportResponse } from "@/gen/reports/overview_pb";
import { RevenueReportResponse } from "@/gen/reports/revenue_pb";
import { pharmacyClient } from "@/connect";

const API_URL = import.meta.env.VITE_API_URL as string;

type Props = {
  overview: OverviewReportResponse;
  revenue: RevenueReportResponse;
};

export const Route = createFileRoute("/(pharma)/_layout/invoicing/")({
  component: Component,
  loader: async (): Promise<Props> => {

    const overviewData = await pharmacyClient.overviewReport({
      startDate: dayjs().startOf('day').unix(),
      endDate: dayjs().endOf('day').unix(),
    })

    const revenueData = await pharmacyClient.revenueReport({
      startDate: dayjs().startOf('year').unix(),
      endDate: dayjs().endOf('year').unix(),
    });

    return {
      overview: overviewData,
      revenue: revenueData,
    };
  },
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
});
